import { call, put, takeLatest } from "redux-saga/effects";
import request, { hashfameRequest } from "utils/request";
import { creatorUsersActions } from "./index";
import { showToast } from "components/ToastContainer/index";

function* fetchCreatorUsers(action) {
  try {
    const queryString = Object.keys(action.payload)
      .map((key) => `${key}=${action.payload[key]}`)
      .join("&");
    const response = yield call(request, `/api/creator_users?${queryString}`, {
      method: "GET"
    });
    yield put(creatorUsersActions.fetchCreatorUsersSuccess(response));
  } catch (error) {
    yield put(creatorUsersActions.fetchCreatorUsersFailure(error.message));
  }
}

function* fetchCreatorUserById(action) {
  try {
    const { userId } = action.payload;
    const response = yield call(request, `/api/creator_users/${userId}`, {
      method: "GET"
    });
    yield put(creatorUsersActions.fetchCreatorUserByIdSuccess(response));
  } catch (error) {
    yield put(creatorUsersActions.fetchCreatorUserByIdFailure(error.message));
  }
}

function* updateCreatorUser(action) {
  try {
    const { userId, updateData } = action.payload;
    const response = yield call(request, `/api/creator_users/${userId}`, {
      method: "PATCH",
      body: JSON.stringify(updateData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      }
    });
    yield put(creatorUsersActions.updateCreatorUserSuccess(response));
    showToast("User updated successfully", "success");
  } catch (error) {
    yield put(creatorUsersActions.updateCreatorUserFailure(error.message));
  }
}

function* fetchBrandFollowers(action) {
  try {
    const queryString = Object.keys(action.payload)
      .map((key) => `${key}=${action.payload[key]}`)
      .join("&");

    const response = yield call(
      request,
      `/api/creator_users_platform_logs?${queryString}`,
      {
        method: "GET"
      }
    );
    yield put(creatorUsersActions.fetchBrandFollowersSuccess(response));
  } catch (error) {
    yield put(creatorUsersActions.fetchBrandFollowersFailure(error.message));
  }
}

function* lowFollowerReviewAction(action) {
  try {
    const {
      creator_user_id,
      action: reviewAction,
      secret_code
    } = action.payload;

    const queryString = new URLSearchParams({
      creator_user_id,
      action: reviewAction,
      secret_code
    }).toString();

    const response = yield call(
      hashfameRequest,
      `/api/v1/approve.reject.low.follower.review?${queryString}`,
      {
        method: "POST" // no body
      }
    );

    yield put(creatorUsersActions.lowFollowerReviewActionSuccess(response));
    showToast(
      reviewAction === "approved"
        ? "Creator approved successfully."
        : "Creator rejected successfully.",
      "success"
    );
  } catch (error) {
    yield put(
      creatorUsersActions.lowFollowerReviewActionFailure(error.message)
    );
    showToast("Failed to perform review action", "danger");
  }
}

function* restrictCreatorUser(action) {
  try {
    const { creator_user_id, secret_code, status } = action.payload;

    const queryString = new URLSearchParams({
      creator_user_id,
      secret_code,
      status
    }).toString();

    const response = yield call(
      hashfameRequest,
      `/api/v1/restrict.creator.user?${queryString}`,
      { method: "GET" }
    );

    yield put(
      creatorUsersActions.restrictCreatorUserSuccess({
        userId: creator_user_id,
        status
      })
    );

    showToast("User restricted successfully", "success");
  } catch (error) {
    yield put(creatorUsersActions.restrictCreatorUserFailure(error.message));
    showToast("Failed to restrict user", "danger");
  }
}

export function* creatorsVerificationSaga() {
  yield takeLatest(
    creatorUsersActions.fetchCreatorUsersRequest.type,
    fetchCreatorUsers
  );
  yield takeLatest(
    creatorUsersActions.fetchCreatorUserByIdRequest.type,
    fetchCreatorUserById
  );
  yield takeLatest(
    creatorUsersActions.updateCreatorUserRequest.type,
    updateCreatorUser
  );
  yield takeLatest(
    creatorUsersActions.fetchBrandFollowersRequest.type,
    fetchBrandFollowers
  );
  yield takeLatest(
    creatorUsersActions.lowFollowerReviewActionRequest.type,
    lowFollowerReviewAction
  );
  yield takeLatest(
    creatorUsersActions.restrictCreatorUserRequest.type,
    restrictCreatorUser
  );
}
